import { z } from "zod";
import { isPeriodValid } from "../../components/form/DatePeriodSelector";

export const editBookingFormDataSchema = z
    .object({
        customerIds: z.array(z.string().uuid()).min(1, "validation.required"),
        productIds: z.array(z.string().uuid()).min(1, "validation.required"),
        discounts: z.record(z.string().uuid(), z.number().min(-100).max(100)),
        startDate: z.date({ required_error: "validation.required" }),
        endDate: z.date({ required_error: "validation.required" }),
        note: z.string(),
        offerId: z.string().uuid().optional().nullable(),
    })
    .refine((data) => isPeriodValid(data.startDate, data.endDate), {
        message: "validation.invalidDatePeriod",
        path: ["endDate"],
    });
